// pages/Community/CommunityTabs.jsx
//
// Breadcrumb + tab-bar header shared across all Community views (mirrors the
// ChatManagement / SeoManagement tab style). Each tab links to its route so the
// active view renders; the current tab is highlighted + shown in the breadcrumb.

import React from "react";
import { Link } from "react-router-dom";

const TABS = [
  { key: "prospects", label: "Prospects" },
  { key: "active", label: "Active" },
  { key: "channels", label: "Channels" },
  { key: "inbox", label: "Inbox" },
  { key: "contacts", label: "Contacts" },
  { key: "automation", label: "Automation" },
  { key: "connectors", label: "Connectors" },
  { key: "analytics", label: "Analytics" },
];

const CommunityTabs = ({ view }) => {
  // Routes pass 'prospect' (singular) for the Prospects view.
  const v = view === "prospect" ? "prospects" : view;
  const active = TABS.find((t) => t.key === v) || TABS[0];
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: "0.78rem", color: "#8a8f98", marginBottom: 8 }}>
        Community <span style={{ margin: "0 6px" }}>›</span>
        <span style={{ color: "#0b3d91", fontWeight: 600 }}>{active.label}</span>
      </div>
      <div style={{ display: "flex", gap: 2, borderBottom: "1px solid #e5e5e5", flexWrap: "wrap" }}>
        {TABS.map((t) => {
          const isActive = v === t.key;
          return (
            <Link
              key={t.key}
              to={`/community/${t.key === "prospects" ? "prospects" : t.key}`}
              style={{
                padding: "8px 16px", textDecoration: "none", fontSize: "0.85rem", fontWeight: 600,
                color: isActive ? "#0b3d91" : "#667085",
                borderBottom: isActive ? "2px solid #0b3d91" : "2px solid transparent",
                marginBottom: -1,
              }}
            >
              {t.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CommunityTabs;
